import "@/plugins/bridge.js";

// 比较版本号
const compareVersion = (v1, v2) => {
  const parts1 = v1.split(".").map(Number);
  const parts2 = v2.split(".").map(Number);
  for (let i = 0; i < 3; i++) {
    const a = parts1[i] || 0;
    const b = parts2[i] || 0;
    if (a !== b) return a - b;
  }
  return 0;
};

// 检查是否支持音频播放桥接
export const checkPlayerSupport = (version) => {
  return new Promise((resolve) => {
    // app环境且版本大于等于9.1.5 才支持调用桥接
    const userAgentString = navigator.userAgent.toLowerCase();
    if (userAgentString.indexOf("zsrbapp") >= 0) {
      if (window.ZsrbApp && window.ZsrbApp.call) {
        window.ZsrbApp.call("systemInfo", {}, (res) => {
          try {
            res = typeof res === "string" ? JSON.parse(res) : res;
            if (
              (res.systemName === "iOS" || res.systemInfo === "Android") &&
              res.version &&
              compareVersion(res.version, version) >= 0
            ) {
              // 符合桥接
              resolve(true);
            } else {
              // 不符合桥接
              resolve(false);
            }
          } catch (e) {
            console.error("systemInfo parse error", e);
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    } else {
      resolve(false);
    }
  });
};

// 获取音频正在播放信息
export const getAudioPlayerInfo = async () => {
  // 检查是否正在播放
  return new Promise((resolve) => {
    try {
      window.ZsrbApp.call("getAudioPlayerInfo", {}, (res) => {
        res = JSON.parse(res);
        resolve(res || { code: -1 });
      });
    } catch (error) {
      console.warn("[ZsplusAudio] getAudioPlayerInfo 调用失败:", error);
      resolve({ code: -1, message: "桥接调用失败" });
    }
  });
};
// 是否显示音频播放控件
export const isShowAudioPlayer = async (value) => {
  // 检查是否正在播放
  window.ZsrbApp.call("isShowAudioPlayer", {
    isShow: value
  });
};
